export default class NodeSet {
  constructor() {
    this.clear();
  }

  add(node) {
    if (this.has(node)) return false;
    this.nodes[node.id] = node;
    ++this._size;
    return true;
  }

  remove(node) {
    if (!this.has(node)) return false;
    delete this.nodes[node.id];
    --this._size;
    return true;
  }

  has(node) {
    return this.nodes[node.id] !== undefined;
  }

  size() {
    return this._size;
  }

  clear() {
    this.nodes = {};
    this._size = 0;
  }

  forEach(fn) {
    Object.keys(this.nodes).forEach(id => {
      fn(this.nodes[id]);
    });
  }
}
